import React, { Component } from "react";
import { Grid as Container, Row, Col } from "react-bootstrap";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col>
              <p className="copyright pull-right">
                &copy; {new Date().getFullYear()}{" "}
                <a>Designed by MangustaTeam</a>,
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx